import React, { Component } from 'react';

class Inputchange extends Component {
  constructor(props){
    super(props)
    this.manualColor={}
    this.timerColor = {}
  }


  render() {
    if(this.props.manual){
      this.manualColor = {color : '#333333'};
      this.timerColor = {};
    }else{
      this.manualColor = {};
      this.timerColor = {color : '#333333'};
    }
    return (
      <div className="changeinput-btn">
        { this.props.active.start ? (
          <button className="active-trash" onClick={this.props.delete.bind(null, this.props.active.id)}>
            <i className="glyphicon glyphicon-trash"></i>
          </button>
        ) : (
          <div className="changeinput-btn-mode">
            <button onClick={this.props.toggle.bind(null, false)} style={this.timerColor}>
              <i className="glyphicon glyphicon-time"></i>
            </button>
            <button onClick={this.props.toggle.bind(null, true)} style={this.manualColor}>
              <i className="glyphicon glyphicon-align-justify"></i>
            </button>
          </div>
        )}

      </div>
    );
  }
}

Inputchange.defaultProps = {
  toggle : () => {},
  manual : false
}

export default Inputchange;
